import { IJSendSuccessResponse } from "typings";
import { fetcher } from "utils";

export const get__api__v1__pay__bank_names = (): Promise<IJSendSuccessResponse<{
  payload: { kcp: string[]; iamport: string[] };
}>> => fetcher.get("/api/v1/pay/bank_names");
